<template>
  <div class="signature-field-container">
    <img
      v-if="!!signatureBiometric"
      class="signature-image"
      :src="signatureBiometric"
      :alt="t('signature')"
    />
    <div v-else class="printed-name">
      {{ fullName }}
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    signatureBiometric: {
      type: String,
      default: '',
    },
    fullName: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.signature-field-container {
  font-size: 50%;
  height: 100%;
  line-height: 1.5;
  overflow-wrap: break-word;
  word-wrap: break-word;
  color: var(--text-gray);

  .signature-image {
    object-fit: contain;
    height: 100%;
    width: 100%;
  }

  .printed-name {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 0.8rem;
    color: var(--text-gray);
  }
}
</style>
